import $ from 'jquery';

Drupal.behaviors.headerOnScroll = {
  attach: function (context) {
    $(function () {
      let throttleScroll;
      const $header = $('.header', context);
      let didScroll;
      let lastScrollTop = 0, delta = 15;
      let headerHeight = $('.header').outerHeight();

      $( window ).on('scroll', function () {
        let st = $( this ).scrollTop();
        if (Math.abs( lastScrollTop - st ) <= delta) {
          return;
        }
  
        if (st >= headerHeight) {
          $('.header__wrapper').removeClass('header--unfixed').addClass('header--fixed');

        } else {
          $('.header__wrapper').removeClass('header--fixed').addClass('header--unfixed');
        }

        if ((st > lastScrollTop) && (lastScrollTop > headerHeight)) {
          // downscroll code
          $( 'body' ).removeClass( 'header--down' ).addClass( 'header--up' );

        } else {
           // upscroll code
          $('body').removeClass('header--up').addClass('header--down');
        } 

        if (st >= headerHeight + 50) {
          $('.header__wrapper').addClass('header--animation');
        } else {
          $('.header__wrapper').removeClass('header--animation');
        }

        lastScrollTop = st;
      });
    });
  }
}